// TEST MODE (manual QA only). When ON it relaxes two front-end gates so a tester can paste
// content and never get interrupted by the Authorship Establishment (AES) overlay:
//   1. OT/composition paste guard becomes a no-op (see otPasteGuard.js).
//   2. The AES "AI/authorship check" overlay is suppressed (see AuthorshipEstablishment.jsx).
// It changes NO backend behavior. Toggle via keyboard shortcut (Cmd/Ctrl+Shift+T) or URL
// (?testmode=1 to turn on, ?testmode=0 to turn off). State persists in localStorage.
const KEY = "tws_test_mode";
export const TEST_MODE_EVENT = "tws-testmode-changed";

// Sync from the URL param once at import time so ?testmode=1|0 wins on page load.
try {
  const v = new URLSearchParams(window.location.search).get("testmode");
  if (v === "1") localStorage.setItem(KEY, "1");
  else if (v === "0") localStorage.removeItem(KEY);
} catch (e) { /* ignore */ }

export const getTestMode = () => {
  try { return localStorage.getItem(KEY) === "1"; } catch (e) { return false; }
};

export const setTestMode = (on) => {
  try {
    if (on) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch (e) { /* ignore */ }
  try { window.dispatchEvent(new CustomEvent(TEST_MODE_EVENT, { detail: { on: !!on } })); } catch (e) { /* ignore */ }
};

export const toggleTestMode = () => { const next = !getTestMode(); setTestMode(next); return next; };
